export enum Orientation {
    Vertical = 1,
    Horizontal = 2
}
